import { ICellRendererParams } from '@ag-grid-community/core'
import intervalToDuration from 'date-fns/intervalToDuration'

export const durationCellRenderer = (params: ICellRendererParams): string => {
  const { value } = params

  if (value == null) {
    return ''
  }

  const duration = intervalToDuration({
    start: 0,
    end: value,
  })

  return `${duration.hours}h ${duration.minutes}m ${duration.seconds}s`
}
